export default {
  state: {
    sidebarActivities: {
      media: false,
      markers: false,
    },
  },
  getters: {},
  mutations: {
    openSidebar(state, payload) {
      if (payload === 'media') {
        state.sidebarActivities['markers'] = false;
      } else {
        state.sidebarActivities['media'] = false;
      }

      state.sidebarActivities[payload] = state.sidebarActivities[payload] ? false : true;
    },
  },
};
